import { mapDTO } from '@twistezo/ts-dto-mapper'

import { dataSamplingFromDTO } from 'features/workspace/mappers/dataSampling'

import type { AuthUserCurrentWorkspaceDTO, AuthUserDTO } from './types'
import type { User, UserCurrentWorkspace } from 'features/user/types/user'

export const authUserCurrentWorkspaceFromDTO = (
  from: AuthUserCurrentWorkspaceDTO,
): UserCurrentWorkspace => ({
  active: from.active,
  alerts: from.alerts,
  id: from.id,
  latestGamConnectionOrder: from.latestGamConnectionOrder ?? undefined,
  name: from.name,
  networkCode: from.networkCode,
  pipedriveLink: from.pipedriveLink,
  prebidManagerSampling: dataSamplingFromDTO(from.prebidManagerSampling),
  priceGeniusAlwaysOn: from.priceGeniusAlwaysOn,
  primaryCurrency: from.primaryCurrency ?? undefined,
})

export const authUserFromDTO = (from: AuthUserDTO): User =>
  mapDTO<AuthUserDTO, User>({ from }).transform(
    (dto: AuthUserDTO): User => ({
      currentWorkspace: dto.currentWorkspace
        ? authUserCurrentWorkspaceFromDTO(dto.currentWorkspace)
        : undefined,
      currentWorkspaceRole: dto.currentWorkspaceRole || undefined,
      email: dto.email,
      features: dto.features,
      firstName: dto.firstName || '',
      id: dto.id,
      lastName: dto.lastName || '',
      role: dto.role,
      workspaceProducts: dto.workspaceProducts || undefined,
      workspaces: dto.workspaces,
    }),
  )
